import { render, staticRenderFns } from "./markList.vue?vue&type=template&id=fe130e84&scoped=true&"
import script from "./markList.vue?vue&type=script&lang=js&"
export * from "./markList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe130e84",
  null
  
)

export default component.exports